// Generate random password
export const generateRandomPassword = () => {
  const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lower = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";
  const special = "!@#$%^&*";
  const all = upper + lower + numbers + special;

  const getRandom = (charset: string) =>
    charset[Math.floor(Math.random() * charset.length)];

  let password = [
    getRandom(upper),
    getRandom(lower),
    getRandom(numbers),
    getRandom(special),
  ];

  for (let i = 0; i < 12; i++) {
    password.push(getRandom(all));
  }

  return password.sort(() => 0.5 - Math.random()).join("");
};
